import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { SubscriptionContainer } from 'src/app/models/subscription-container';
import { DockPosition } from 'src/app/services/window-manager';

export namespace BaseWidgetComponent {
  export type Event<T = {}> = { id: string } & T;
  export type DockEvent = Event<{ position: DockPosition }>;
}

@Component({
    selector: 'app-base-widget',
    templateUrl: './base-widget.component.html',
    styleUrls: ['./base-widget.component.scss'],
    standalone: false
})
export class BaseWidgetComponent implements OnDestroy {
  @Input() teamName: string;
  @Input() id: string = 'BaseWidget';
  @Input() parentId: string;
  @Input() isMaximized: boolean = false;
  @Input() isEmbedded: boolean = false;

  // Use setter/getter for isDocked to allow child classes to override
  @Input() set isDocked(value: boolean) {
    this._isDocked = value;
  }
  get isDocked(): boolean {
    return this._isDocked;
  }
  protected _isDocked: boolean = false;

  @Output() onClose = new EventEmitter<BaseWidgetComponent.Event>();
  @Output() onRestore = new EventEmitter<BaseWidgetComponent.Event>();
  @Output() onMaximize = new EventEmitter<BaseWidgetComponent.Event>();
  @Output() onToggle = new EventEmitter<BaseWidgetComponent.Event>();
  @Output() onDock = new EventEmitter<BaseWidgetComponent.DockEvent>();
  @Output() onUndock = new EventEmitter<BaseWidgetComponent.Event>();


  public widgetView: 'NEW' | 'LIST' | 'DETAIL' | 'INSPECT' = 'LIST';
  protected _subs = new SubscriptionContainer();

  constructor() {}

  ngOnDestroy(): void {
    this._subs.dispose();
  }

  public close() {
    this.onClose.emit({ id: this.id });
  }

  public restore() {
    this.onRestore.emit({ id: this.id });
    this.isMaximized = false;
  }

  public maximize() {
    this.onMaximize.emit({ id: this.id });
    this.isMaximized = true;
  }

  public toggle() {
    this.onToggle.emit({ id: this.id });
    this.isMaximized = !this.isMaximized;
  }

  public dock(position: DockPosition) {
    console.log('BaseWidget.dock called with position:', position, 'id:', this.id);
    this.onDock.emit({ id: this.id, position });
    this.isDocked = true;  // Use setter so child class overrides get called
  }

  public undock() {
    this.onUndock.emit({ id: this.id });
    this.isDocked = false;  // Use setter so child class overrides get called
  }
}
